var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ckeditor',{style:({ width: _vm.width == null ? null : _vm.width + 'px' }),attrs:{"value":_vm.value,"readOnly":_vm.readonly,"editorUrl":_vm.editorUrl,"config":_vm.config},on:{"input":$event => _vm.$emit('input', $event)}})
}
var staticRenderFns = []

export { render, staticRenderFns }